/**
 * Import Packery
 */
import Packery from 'packery';


/**
 * Import ImagesLoaded
 */
import imagesLoaded from 'imagesloaded';


/**
 * Init Packery
 */
$(document).ready(function () {
    setTimeout(function () {
            if ($(window).width() > 991) {
                $(function () {
                    var msnryElements = document.getElementsByClassName("oe-masonry-gallery"),
                        msnry;

                    imagesLoaded(document.querySelector('body'), function () {
                        var n = msnryElements.length;

                        for (var i = 0; i < n; i++) {
                            msnry = new Packery(msnryElements[i], {
                                itemSelector: '.grid-item',
                                gutter: 30
                            });
                        }
                    });
                });
            } else {
                $(function () {
                    var msnryElements = document.getElementsByClassName("oe-masonry-gallery"),
                        msnry;

                    imagesLoaded(document.querySelector('body'), function () {
                        var n = msnryElements.length;

                        for (var i = 0; i < n; i++) {
                            msnry = new Packery(msnryElements[i], {
                                itemSelector: '.grid-item',
                                gutter: 15
                            });
                        }
                    });
                });
            }
        }
        , 100);
});

